<template>
  <div class="sideBarLine">
    <span class="line"></span>
    <span class="sideBarTitle">{{title}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "sideBarLine",
  props:{
    title:String
  },
  methods:{
    back(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

</style>
<style lang="less">
  .sideBarLine{
    padding:13px 15px;
    position: relative;
    .line{
      width: 4px;
      height: 15px;
      background: #1D80FF;
      border-radius: 2px;
      display: inline-block;
      margin-right: 8px;
      vertical-align: middle;
    }
    .sideBarTitle{
      color: #1D80FF;
      font-size: 14px;
      vertical-align: middle;
      font-weight: bold;
    }
  }
  
</style>




// WEBPACK FOOTER //
// src/components/sideBarLine.vue